import React from 'react'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'
import Error403 from './Error403'
import Error404 from './Error404'
import Error500 from './Error500'

const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError()

  let status = 500
  let message = 'Something went wrong.'

  if (isRouteErrorResponse(error)) {
    status = error.status
    try {
      message = typeof error.data === 'string' ? error.data : error.data?.message || message
    } catch {
      // ignore
    }
  } else if (error instanceof Response) {
    // Handle Responses thrown directly from components (not just loaders/actions)
    status = error.status
  } else if (error instanceof Error) {
    message = error.message
  }

  // Render specific error pages based on HTTP status
  if (status === 404) {
    return <Error404 />
  }

  if (status === 403) {
    return <Error403 />
  }

  // Default to 500 or unknown errors
  return <Error500 />
}

export default RouteErrorBoundary
